// src/services/publicCaisseService.js
import axios from 'axios';
import { baseURL } from '../utils/config';

const publicApi = axios.create({
  baseURL: baseURL,
  headers: { 'Content-Type': 'application/json' },
});

const tenantURL = (slug, path) => `/${slug}/${path}`;

/**
 * Vérification publique de l'authenticité d'un reçu — appelée depuis
 * /verifier-recu/:uuid après scan du QR code. Aucune authentification
 * requise côté backend (AllowAny) ; on utilise une instance axios dédiée,
 * indépendante de tout token utilisateur, pour éviter tout effet de bord
 * d'un intercepteur d'authentification (cf. publicAuthService.js).
 * GET /api/<slug>/caisse/versements/verifier/<uuid>/
 */
export const verifierRecu = async (slug, uuid) => {
  try {
    const response = await publicApi.get(tenantURL(slug, `caisse/versements/verifier/${uuid}/`));
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la vérification du reçu:", error);
    throw error;
  }
};

export default { verifierRecu };